import { getAuthCode } from "./getAuthCode";
export const finishPostLive = async (id, setPending, setLiveContent) => {
  try {
    let callURL = process.env.REACT_APP_BACKEND_URL + "/finishpostlive";
    const response = await fetch(callURL, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ auth_code: await getAuthCode(), ideaId: id }),
    });

    if (!response.ok) return false;

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let accumulated = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const text = decoder.decode(value, { stream: true });
      const lines = text.split("\n");

      for (const line of lines) {
        if (line.startsWith("data: ")) {
          const payload = line.slice(6).trim();
          if (payload === "[DONE]") {
            setPending(false);
            return accumulated;
          }
          try {
            const parsed = JSON.parse(payload);
            if (parsed.content) {
              accumulated += parsed.content;
              setLiveContent(accumulated);
            }
          } catch (_) {}
        }
      }
    }

    setPending(false);
    return accumulated;
  } catch (error) {
    console.log(error);
  }
};